/* TEN BUT — Scroll restoration: força retorno ao topo no reload */
(function () {
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  window.scrollTo(0, 0);
})();

/* TEN BUT — Hide hCaptcha badge (MutationObserver para elementos injetados dinamicamente) */
(function () {
  function hideIfHCaptcha(node) {
    if (node.nodeType !== 1) return;
    var id    = (node.id        || '').toLowerCase();
    var cls   = (node.className || '').toLowerCase();
    var src   = (node.src       || '').toLowerCase();
    var title = (node.title     || '').toLowerCase();
    if (id.includes('hcaptcha') || cls.includes('hcaptcha') ||
        src.includes('hcaptcha') || title.includes('hcaptcha')) {
      node.style.setProperty('display', 'none', 'important');
    }
    if (node.querySelectorAll) {
      node.querySelectorAll(
        '[id*="hcaptcha"],[class*="hcaptcha"],[data-hcaptcha-widget-id],' +
        'iframe[src*="hcaptcha"],iframe[title*="hcaptcha" i]'
      ).forEach(function (el) {
        el.style.setProperty('display', 'none', 'important');
      });
    }
  }

  var hcObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(hideIfHCaptcha);
    });
  });

  function startObserver() {
    hcObserver.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver);
  } else {
    startObserver();
  }
})();

/* TEN BUT — Countdown Timer */
(function () {
  function initCountdowns() {
    document.querySelectorAll('[data-tb-countdown]').forEach(function (el) {
      var endDate = el.getAttribute('data-tb-countdown');
      if (!endDate) return;

      var end = new Date(endDate).getTime();

      function tick() {
        var now = Date.now();
        var diff = end - now;

        if (diff <= 0) {
          el.textContent = '00:00:00';
          return;
        }

        var h = Math.floor(diff / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);

        el.textContent =
          String(h).padStart(2, '0') + ':' +
          String(m).padStart(2, '0') + ':' +
          String(s).padStart(2, '0');

        setTimeout(tick, 1000);
      }

      tick();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCountdowns);
  } else {
    initCountdowns();
  }
})();

/* TEN BUT — Newsletter AJAX */
(function () {
  function attachNewsletterAjax(form, container) {
    var submitBtn = container.querySelector('[data-tb-newsletter-submit]');
    var successEl = container.querySelector('[data-tb-newsletter-success]');
    var errorEl = container.querySelector('[data-tb-newsletter-error]');
    var emailInput = form.querySelector('[name="contact[email]"]');
    var originalLabel = submitBtn ? submitBtn.textContent.trim() : '';
    var pending = false;

    /* Capture phase + stopImmediatePropagation bloqueia handlers do tema Horizon
       que fazem form.submit() nativo em resposta ao mesmo evento */
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();

      if (pending) return;
      pending = true;

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = '...';
      }
      if (successEl) successEl.hidden = true;
      if (errorEl) errorEl.hidden = true;

      /* AJAX fire-and-forget para /contact (form de customer). Funciona porque
         a proteção anti-spam/hCaptcha do form de contato está DESLIGADA no
         admin do Shopify — com ela ligada, o endpoint exige o token e o POST
         via fetch retorna 400. Não inspecionar response.ok/type: Shopify
         responde 302 e isso é frágil (opaque/cross-origin/cache). Mesmo padrão
         do discount panel. Só trata falha real de rede no .catch. */
      fetch('/contact', {
        method: 'POST',
        body: new FormData(form)
      })
      .then(function () {
        if (successEl) successEl.hidden = false;
        if (emailInput) emailInput.value = '';
      })
      .catch(function () {
        if (errorEl) errorEl.hidden = false;
      })
      .finally(function () {
        pending = false;
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = originalLabel;
        }
      });
    }, true); /* true = capture phase — roda antes dos handlers do tema */
  }

  function initNewsletterForms() {
    document.querySelectorAll('[data-tb-newsletter-block]').forEach(function (block) {
      var form = block.querySelector('form');
      if (form) attachNewsletterAjax(form, block);
    });

    document.querySelectorAll('form[data-tb-newsletter-form]').forEach(function (form) {
      var container = form.closest('section') || form.parentElement;
      if (container) attachNewsletterAjax(form, container);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNewsletterForms);
  } else {
    initNewsletterForms();
  }
})();

/* TEN BUT — Discount Panel */
(function () {
  if (window.__tbDiscountInit) return;
  window.__tbDiscountInit = true;
  var KEY_CLAIMED = 'tb_discount_claimed';
  var KEY_DISMISSED = 'tb_discount_dismissed';

  function lsGet(key) {
    try { return localStorage.getItem(key); } catch (e) { return null; }
  }

  function lsSet(key) {
    try { localStorage.setItem(key, '1'); } catch (e) {}
  }

  function initDiscountPanel() {
    var panel = document.getElementById('tb-discount-panel');
    if (!panel) return;

    /* Oculta permanentemente se já submeteu ou já dispensou */
    if (lsGet(KEY_CLAIMED) || lsGet(KEY_DISMISSED)) {
      return;
    }

    /* Passa no check — revela o painel */
    panel.style.display = '';

    var btnWrap = document.getElementById('tb-discount-btn-wrap');
    var btn = document.getElementById('tb-discount-btn');
    var dismissBtn = document.getElementById('tb-discount-btn-dismiss');
    var drawer = document.getElementById('tb-discount-drawer');
    var overlay = document.getElementById('tb-discount-overlay');
    var closeBtn = document.getElementById('tb-discount-close');
    var form = document.getElementById('tb-discount-form');

    /* _scrollGuard: blocks scroll-triggered close (iOS keyboard open = micro-scroll).
       _touchingDrawer: blocks phantom-click on overlay after touch inside drawer.
       Both problems cause the panel to close when the user taps the email field. */
    var _scrollGuard = false;
    var _touchingDrawer = false;

    function armScrollGuard() {
      _scrollGuard = true;
      clearTimeout(armScrollGuard._t);
      armScrollGuard._t = setTimeout(function () { _scrollGuard = false; }, 800);
    }

    function openPanel() {
      panel.classList.add('tb-discount-panel--open');
      panel.setAttribute('aria-hidden', 'false');
      btn.setAttribute('aria-expanded', 'true');
      drawer.removeAttribute('aria-hidden');
      armScrollGuard();
    }

    function closePanel() {
      panel.classList.remove('tb-discount-panel--open');
      panel.setAttribute('aria-hidden', 'true');
      btn.setAttribute('aria-expanded', 'false');
      drawer.setAttribute('aria-hidden', 'true');
    }

    btn.addEventListener('click', openPanel);
    closeBtn.addEventListener('click', closePanel);

    /* Overlay closes panel — but not if triggered by a phantom click that
       originated inside the drawer (iOS repositions click coords on keyboard open) */
    overlay.addEventListener('click', function () {
      if (!_touchingDrawer && !_scrollGuard) closePanel();
    });

    /* Prevent overlay touchmove from triggering carousel swipes beneath */
    overlay.addEventListener('touchmove', function (e) {
      e.preventDefault();
    }, { passive: false });

    /* Track touches inside the drawer so we can suppress phantom overlay clicks */
    drawer.addEventListener('touchstart', function () {
      _touchingDrawer = true;
    }, { passive: true });
    drawer.addEventListener('touchend', function () {
      /* Keep flag active long enough for iOS synthetic click to fire (~300ms),
         but re-arm scroll guard too because keyboard will open shortly */
      armScrollGuard();
      setTimeout(function () { _touchingDrawer = false; }, 600);
    }, { passive: true });

    /* Re-arm scroll guard when email input gets focus (keyboard opens = scroll) */
    var emailInput = document.getElementById('tb-discount-email');
    if (emailInput) {
      emailInput.addEventListener('focus', armScrollGuard);
    }

    /* Zona do X na imagem — dispensa permanentemente */
    if (dismissBtn) {
      dismissBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        lsSet(KEY_DISMISSED);
        panel.style.display = 'none';
      });
    }

    window.addEventListener('scroll', function () {
      if (!_scrollGuard && panel.classList.contains('tb-discount-panel--open')) {
        closePanel();
      }
    }, { passive: true });

    /* Esconde botão quando footer está visível */
    var footer = document.querySelector('footer');
    if (footer && btnWrap) {
      var footerObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            btnWrap.classList.add('tb-discount-panel__btn-wrap--hidden');
          } else {
            btnWrap.classList.remove('tb-discount-panel__btn-wrap--hidden');
          }
        });
      }, { threshold: 0.05 });
      footerObserver.observe(footer);
    }

    /* Submit — AJAX sem reload; salva como "claimed" e esconde o painel */
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();

      lsSet(KEY_CLAIMED);

      fetch('/contact', {
        method: 'POST',
        body: new FormData(form)
      }).finally(function () {
        panel.style.display = 'none';
      });
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDiscountPanel);
  } else {
    initDiscountPanel();
  }
})();

/* TEN BUT — Story 4.4: Defer filter auto-submit + Aplicar/Limpar + badge sync */
(function () {
  /* Fix price input placeholders: CSS already hides the numeric range_max value;
     after JS sets the text and adds .tb-ph-set the placeholder becomes visible */
  function fixPricePlaceholders(el) {
    var minIn = el.querySelector('[ref="minInput"]');
    var maxIn = el.querySelector('[ref="maxInput"]');
    if (minIn) { minIn.placeholder = 'Mín.'; minIn.classList.add('tb-ph-set'); }
    if (maxIn) { maxIn.placeholder = 'Máx.'; maxIn.classList.add('tb-ph-set'); }
  }

  /* Shopify disables filter options that return 0 results for the current
     combination. With defer-submit the user should freely explore any
     combination before clicking Apply, so we remove the HTML disabled
     attribute and the --disabled CSS class from all filter items. */
  function enableAllFilterOptions(el) {
    /* O disabled server-side vem em 3 formas: classe no <li>, classe no
       wrapper .checkbox e atributo no <input> (pílulas de tamanho só têm o
       atributo, sem classe — por isso o strip por classe não bastava). */
    el.querySelectorAll('.facets__inputs-list-item--disabled, .checkbox--disabled').forEach(function (item) {
      item.classList.remove('facets__inputs-list-item--disabled');
      item.classList.remove('checkbox--disabled');
    });
    el.querySelectorAll('input[disabled]').forEach(function (input) {
      input.removeAttribute('disabled');
    });
  }

  function patchFacetsForm(el) {
    if (el.__tbPatched) return;
    var orig = el.updateFilters.bind(el);
    el.__tbOriginalUpdate = orig;
    el.updateFilters = function () {};
    el.__tbPatched = true;
    /* Two rAFs ensure all children (price inputs, filter items) are in DOM */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        fixPricePlaceholders(el);
        enableAllFilterOptions(el);
      });
    });
  }

  /* Sync the count badge (e.g. "3") in an accordion header when a checkbox
     changes, without triggering a full section re-render */
  function syncBadge(checkbox) {
    var inputs = checkbox.closest('facet-inputs-component');
    if (!inputs) return;
    var details = inputs.closest('details');
    if (!details) return;
    var statusSpan = details.querySelector(
      'facet-status-component[facet-type="list"] [ref="facetStatus"]'
    );
    if (!statusSpan) return;
    var count = inputs.querySelectorAll('input[type="checkbox"]:checked').length;
    statusSpan.textContent = count > 0 ? String(count) : '';
    statusSpan.classList.toggle('bubble', count > 0);
    statusSpan.classList.toggle('facets__bubble', count > 0);
  }

  /* Gate 19.3 / BLOCK-005 — cinto do lado do JS. A remoção de pílula é AJAX
     (`facet-remove-component.removeFilter` → `updateFiltersByURL` → `history.pushState`),
     logo NÃO recarrega e nunca passa pelo script do <head>. Sem isto, qualquer
     transição futura que monte uma URL à mão volta a abrir o beco sem saída. A regra
     é uma só, nos dois sentidos: tamanho aceso ⇒ condição presente; sem tamanho ⇒
     condição ausente. */
  function tbEnforceAvailability(url) {
    try {
      var u = new URL(url, window.location.origin);
      var hasSize = u.searchParams.getAll("filter.v.option.rozmiar").length > 0;
      var hasAvailability = u.searchParams.has("filter.v.availability");
      if (hasSize && !hasAvailability) u.searchParams.append("filter.v.availability", "1");
      else if (!hasSize && hasAvailability) u.searchParams.delete("filter.v.availability");
      else return url;
      return u.pathname + (u.search || "") + u.hash;
    } catch (err) {
      return url;
    }
  }

  function syncAvailabilityConstraint(form) {
    var native = form && form.querySelector("form[action]");
    if (!native) return;
    native.querySelectorAll("input[data-tb-availability-constraint]").forEach(function (input) { input.remove(); });
    var selectedSizes = native.querySelectorAll("input[type=\"checkbox\"][name=\"filter.v.option.rozmiar\"]:checked");
    if (selectedSizes.length) {
      var availability = document.createElement("input");
      availability.type = "hidden";
      availability.name = "filter.v.availability";
      availability.value = "1";
      availability.setAttribute("data-tb-availability-constraint", "true");
      native.appendChild(availability);
    }
  }

  function init() {
    /* Patch prototype connectedCallback — all future instances (post re-render) get patched */
    customElements.whenDefined('facets-form-component').then(function () {
      var Cls = customElements.get('facets-form-component');
      if (!Cls) return;
      /* Toda transição por URL (pílula de remover, limpar tudo, qualquer chamada
         futura) passa por aqui — um único sítio a garantir a invariante. */
      if (!Cls.__tbAvailUrlPatched && typeof Cls.prototype.updateFiltersByURL === 'function') {
        Cls.__tbAvailUrlPatched = true;
        var origUpdateByURL = Cls.prototype.updateFiltersByURL;
        Cls.prototype.updateFiltersByURL = function (url) {
          return origUpdateByURL.call(this, tbEnforceAvailability(url));
        };
      }
      if (Cls.__tbCbPatched) return;
      Cls.__tbCbPatched = true;
      var origCb = Cls.prototype.connectedCallback;
      Cls.prototype.connectedCallback = function () {
        origCb && origCb.call(this);
        if (this.hasAttribute('data-tb-defer-submit')) patchFacetsForm(this);
      };
      /* Patch instance already in the DOM */
      var cur = document.querySelector('facets-form-component[data-tb-defer-submit]');
      if (cur) patchFacetsForm(cur);
    });

    /* O Aplicar re-renderiza a section via morph AJAX (não é navegação) e o
       server devolve as opções 0-result com disabled de novo — sem reconectar
       o custom element, então o patch do connectedCallback não roda. Observer
       contínuo faz o strip sempre que o disabled reaparecer. Sem loop: remover
       o atributo dispara o callback uma vez, que não acha nada e para. */
    new MutationObserver(function () {
      var sb = document.getElementById('tb-filter-sidebar');
      if (!sb) return;
      if (sb.querySelector('input[disabled], .facets__inputs-list-item--disabled, .checkbox--disabled')) {
        enableAllFilterOptions(sb);
      }
      /* O mesmo morph troca os inputs de preço e derruba o .tb-ph-set —
         sem ele o placeholder fica transparente (campo "em branco"). */
      if (sb.querySelector('.price-facet__input:not(.tb-ph-set)')) {
        fixPricePlaceholders(sb);
      }
    }).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['disabled']
    });

    /* Badge sync on checkbox change (event delegation — survives re-renders) */
    document.addEventListener('change', function (e) {
      if (e.target.type !== 'checkbox') return;
      var sidebar = document.getElementById('tb-filter-sidebar');
      if (sidebar && sidebar.contains(e.target)) {
        syncBadge(e.target);
        if (e.target.checked && e.target.name === "filter.v.option.rozmiar") {
          try { window.tbTrack("size_selected", { selected_size: e.target.value, item_list_name: "catalog_filter" }); } catch (err) {}
        }
      }
    });

    /* Aplicar + Limpar: single delegated click handler */
    document.addEventListener('click', function (e) {
      if (e.target.closest('#tb-filter-apply')) {
        var form = document.querySelector('facets-form-component[data-tb-defer-submit]');
        if (form && form.__tbOriginalUpdate) {
          syncAvailabilityConstraint(form);
          /* Coleção-atalho (woman, man...): o updateFilters do Horizon aplica os
             filtros na URL ATUAL via morph AJAX, e buscar ex. "Buty" dentro da
             coleção de botki dá zero resultado. Quando o action do form (sempre
             o catálogo /collections/all) difere da página, navega de verdade
             pra lá com os filtros escolhidos. */
          var native = form.querySelector('form[action]');
          var actionPath = native
            ? new URL(native.getAttribute('action'), window.location.origin).pathname
            : window.location.pathname;
          if (actionPath !== window.location.pathname && typeof form.createURLParameters === 'function') {
            var params = form.createURLParameters();
            var hasSize = false;
            params.forEach(function (v, k) { if (k === "filter.v.option.rozmiar" && v) hasSize = true; });
            if (hasSize && !params.has("filter.v.availability")) params.append("filter.v.availability", "1");
            var dest = new URL(actionPath, window.location.origin);
            params.forEach(function (v, k) { dest.searchParams.append(k, v); });
            window.location.assign(dest.toString());
            return;
          }
          form.__tbOriginalUpdate();
          if (window.innerWidth < 750 && window.__tbCloseDrawer) window.__tbCloseDrawer();
        }
        return;
      }
      if (e.target.closest('#tb-filter-reset')) {
        /* Limpar NÃO recarrega a página (o reload fechava o drawer e obrigava
           a pessoa a abrir o filtro de novo). Só zera as seleções localmente;
           o Aplicar é quem leva o estado limpo pro resultado. */
        var sb = document.getElementById('tb-filter-sidebar');
        if (!sb) return;
        sb.querySelectorAll('input[type="checkbox"]:checked').forEach(function (cb) {
          cb.checked = false;
        });
        sb.querySelectorAll('.price-facet__input').forEach(function (inp) {
          inp.value = '';
        });
        /* Zera os badges de contagem dos grupos (accordions) */
        sb.querySelectorAll('facet-status-component [ref="facetStatus"]').forEach(function (s) {
          s.textContent = '';
          s.classList.remove('bubble', 'facets__bubble');
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* TEN BUT — Story 4.4: Filter Sidebar Drawer (mobile) */
(function () {
  function getSidebar() { return document.getElementById('tb-filter-sidebar'); }
  function getOverlay() { return document.getElementById('tb-filter-overlay'); }

  function openDrawer() {
    var s = getSidebar();
    var o = getOverlay();
    if (!s) return;
    s.classList.add('is-open');
    if (o) o.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    var s = getSidebar();
    var o = getOverlay();
    if (!s) return;
    s.classList.remove('is-open');
    if (o) o.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  /* Expose closeDrawer so the Aplicar handler can reuse it */
  window.__tbCloseDrawer = closeDrawer;

  function initFilterDrawer() {
    /* Event delegation on document — survives section re-renders that
       replace #tb-filter-open, #tb-filter-close and the overlay element */
    document.addEventListener('click', function (e) {
      if (e.target.closest('#tb-filter-open')) {
        openDrawer();
        return;
      }
      if (e.target.closest('#tb-filter-close')) {
        closeDrawer();
        return;
      }
      /* Overlay backdrop click: target must be the overlay itself, not
         something inside the sidebar that happens to be z-indexed above */
      if (
        e.target.closest('#tb-filter-overlay') &&
        !e.target.closest('#tb-filter-sidebar')
      ) {
        closeDrawer();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        var s = getSidebar();
        if (s && s.classList.contains('is-open')) closeDrawer();
      }
    });

    /* Safety net: if the section re-renders while the drawer is open,
       the new sidebar won't have is-open but body.overflow stays hidden.
       Reset it whenever results-list replaces its children. */
    var rl = document.querySelector('results-list[section-id]');
    if (rl) {
      new MutationObserver(function () {
        var s = getSidebar();
        if (s && !s.classList.contains('is-open')) {
          document.body.style.overflow = '';
        }
      }).observe(rl, { childList: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFilterDrawer);
  } else {
    initFilterDrawer();
  }
})();

/* TEN BUT — desativa hover JS dos cards Horizon (collection/search/recommendations).
   Hover passa a ser CSS puro via .card-gallery:hover slideshow-slide[index="1"] em ten-but.css.
   Razão: o slideshow JS do Horizon é frágil em pointerenter/pointerleave após AJAX
   re-render do filtro, deixando cards travados. CSS hover é determinístico e não
   depende de eventos — funciona em qualquer estado do DOM, qualquer filtro, qualquer browser. */
(function () {
  customElements.whenDefined('product-card').then(function () {
    var Cls = customElements.get('product-card');
    if (!Cls || Cls.__tbHoverDisabled) return;
    Cls.__tbHoverDisabled = true;
    Cls.prototype.previewImage = function () {};
    Cls.prototype.resetImage = function () {};
  });
})();

/* TEN BUT — Story 19.1 — Instrumentação de comportamento (`window.tbTrack`). Fachada ÚNICA:
   nenhum outro arquivo do tema fala com o GA4. Contrato: docs/instrumentacao-eventos.md.
   Tudo em try/catch — instrumentação é passageiro, não motorista. */
(function () {
  if (window.__tbAnalyticsInit) return;
  window.__tbAnalyticsInit = true;

  var GA4_ID = 'G-LYQPP4X2YD';
  var CONSENT_KEY = 'ten_but_cookie_consent';
  var MQ_MOBILE = '(max-width: 989px)'; /* mesma régua da barra fixa: uma só definição de mobile */
  var MAX_QUEUE = 50;
  var CARD_LINKS = '.product-card__link, .tb-product-card__media-link, .tb-product-card__name-link';

  var queue = [];
  var debug = false;
  try { debug = new URLSearchParams(location.search).get('tb_debug') === '1'; } catch (e) {}

  /* null = ainda não escolheu OU a escolha é de uma política ANTERIOR (enfileira até a nova
     escolha); true/false = escolha registrada e VÁLIDA. O gate é o MESMO de ten-but-consent.js
     (`saved.v === POLICY_VERSION`): quando a versão sobe, o banner volta a aparecer e a escolha
     velha deixa de valer — não pode continuar autorizando envio aqui. A versão sai do próprio
     módulo de consent (fonte única; os dois assets carregam `defer`, na ordem do documento). */
  function analyticsConsent() {
    try {
      var saved = JSON.parse(localStorage.getItem(CONSENT_KEY));
      var version = window.__tbConsentPolicyVersion || 1;
      return saved && saved.v === version ? !!saved.analytics : null;
    } catch (e) { return null; }
  }

  /* Composto no ENVIO, nunca na init: ten-but.js carrega antes de ten-but-attribution.js, que só
     grava a origem no DOMContentLoaded. REUSE: a origem sai de lá, não é relida aqui.
     Campo sem valor é OMITIDO, nunca vai null/"". */
  function buildPayload(params) {
    var out = {};
    for (var k in params) {
      if (!Object.prototype.hasOwnProperty.call(params, k)) continue;
      if (params[k] === null || params[k] === undefined || params[k] === '') continue;
      out[k] = params[k];
    }
    try { out.page_location = location.href; } catch (e) {}
    try { out.device_type = matchMedia(MQ_MOBILE).matches ? 'mobile' : 'desktop'; } catch (e) {}
    try {
      var t = window.tbAttribution && window.tbAttribution.getLastTouch();
      if (t && (t.utm_source || t.utm_medium)) {
        out.traffic_source = (t.utm_source || '(none)') + '/' + (t.utm_medium || '(none)');
      }
    } catch (e) {}
    if (debug) out.debug_mode = true;
    return out;
  }

  function send(name, payload) {
    try {
      payload.send_to = GA4_ID;
      if (typeof gtag === 'function') gtag('event', name, payload);
      if (debug) console.debug('[tbTrack]', name, payload);
    } catch (e) {}
  }

  function track(name, params) {
    try {
      if (!name) return;
      var payload = buildPayload(params);
      /* `consent_choice` é a ÚNICA exceção: sai sempre, inclusive de quem recusa (Consent Mode
         manda ping sem cookie) — dado que não se obtém retroativamente. */
      if (name === 'consent_choice') return send(name, payload);
      var consent = analyticsConsent();
      /* Sem escolha, espera em MEMÓRIA (teto de 50, descarta os mais antigos). Negado ⇒ descarta. */
      if (consent === null) {
        queue.push({ n: name, p: payload });
        if (queue.length > MAX_QUEUE) queue.shift();
      } else if (consent) send(name, payload);
    } catch (e) {}
  }

  /* Drenagem pelo evento que ten-but-consent.js JÁ dispara (mesmo padrão do ten-but-clarity.js). */
  document.addEventListener('tb:consent', function (e) {
    var granted = !!(e && e.detail && e.detail.analytics);
    var pending = queue;
    queue = [];
    if (granted) pending.forEach(function (it) { send(it.n, it.p); });
  });

  /* De QUAL lista veio o clique. `product-card` NÃO é só o catálogo: a mesma tag sai nas
     recomendações da PDP (<product-recommendations>) e na busca — as três chegariam como
     `catalog`. O `index` é contado DENTRO do container da lista, nunca sobre a página inteira
     (numa PDP isso somaria o carrossel de recomendações ao resto). Esta story cria a LINHA DE
     BASE das Waves 3 e 4: lista contaminada no dia 1 não se limpa retroativamente. */
  function listOf(card) {
    var scope;
    if (card.classList.contains('tb-product-card')) {
      return { name: 'home_drop_grid', scope: card.closest('.tb-drop-grid') || document, item: '.tb-product-card' };
    }
    scope = card.closest('product-recommendations');
    if (scope) return { name: 'recommendations', scope: scope, item: 'product-card' };
    /* Catálogo e busca compartilham `.collection-wrapper`; só a rota distingue (com ou sem
       prefixo de idioma). */
    scope = card.closest('.collection-wrapper');
    if (scope) {
      var isSearch = /(^|\/)search(\/|$)/.test(location.pathname);
      return { name: isSearch ? 'search' : 'catalog', scope: scope, item: 'product-card' };
    }
    scope = card.closest('.resource-list');
    if (scope) return { name: 'product_list', scope: scope, item: 'product-card' };
    return { name: 'other', scope: card.closest('.shopify-section') || document, item: 'product-card' };
  }

  /* `select_item` nos DOIS renderizadores de card, UM listener delegado (o catálogo chega a 24
     cards). `capture` para sair antes de quem pare a propagação; sem preventDefault, sem await. */
  document.addEventListener('click', function (e) {
    try {
      var link = e.target && e.target.closest && e.target.closest(CARD_LINKS);
      var card = link && link.closest('product-card, .tb-product-card');
      if (!card) return;
      var list = listOf(card);
      var all = list.scope.querySelectorAll(list.item);
      var hidden = link.querySelector('.visually-hidden');
      var payload = {
        product_id: card.getAttribute('data-product-id'),
        product_name: card.getAttribute('data-product-name') || (hidden && hidden.textContent.trim()),
        item_list_name: list.name,
        index: Array.prototype.indexOf.call(all, card) + 1
      };
      /* Story 19.10 (AC-D2): quando o bloco de recomendações está filtrado por número, o clique
         leva o tamanho que filtrou a lista. A dimensão `selected_size` JÁ existe no GA4 (19.1) —
         e `item_list_name` continua `recommendations`: criar valor novo contaminaria a linha de
         base que a 19.1 abriu e isso não se limpa retroativamente. */
      if (list.scope && list.scope.getAttribute) {
        var sizeFilter = list.scope.getAttribute('data-tb-size-filter');
        if (sizeFilter) payload.selected_size = sizeFilter;
      }
      track('select_item', payload);
    } catch (err) {}
  }, true);

  /* Substitui o stub do <head> e drena o que ele guardou. Um tick DEPOIS do DOMContentLoaded de
     propósito: ten-but-attribution.js registra o listener dele depois deste arquivo. */
  function init() {
    setTimeout(function () {
      var pending = window.tbTrackQ || [];
      window.tbTrack = track;
      window.tbTrackQ = null;
      for (var i = 0; i < pending.length; i++) {
        try { track(pending[i][0], pending[i][1]); } catch (e) {}
      }
    }, 0);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
